const config = require('../config')
module.exports = {
    api: config.server + '/api/',
    qrApi: config.server+'/',
    // api: '/api/',
    timeout: 600000
}
